import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  CampaignPerformanceSource,
  getCampaignClickPercentage,
  getCampaignClicks,
  getCampaignConversionPercentage,
  getCampaignConversions,
  getCampaignImpressionsAndOpens,
  getCampaignPerformanceData,
  getCampaignRevenue,
} from '../../utils/campaign-performance.util';

type PerformanceIcon = 'impressions' | 'clicks' | 'conversions' | 'revenue';

interface PerformanceMetricRow {
  icon: PerformanceIcon;
  label: string;
}

@Component({
  selector: 'app-campaign-performance-cell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './campaign-performance-cell.component.html',
  styleUrl: './campaign-performance-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignPerformanceCellComponent {
  @Input({ required: true }) campaign!: CampaignPerformanceSource;

  get performanceData() {
    return getCampaignPerformanceData(this.campaign);
  }

  get metricRows(): PerformanceMetricRow[] {
    const data = this.performanceData;
    return [
      {
        icon: 'impressions',
        label: `${getCampaignImpressionsAndOpens(data)} Impressions & Opens`,
      },
      {
        icon: 'clicks',
        label: `${getCampaignClicks(data)} Clicks (${getCampaignClickPercentage(data)}%)`,
      },
      {
        icon: 'conversions',
        label: `${getCampaignConversions(data)} Conversions (${getCampaignConversionPercentage(data)}%)`,
      },
      {
        icon: 'revenue',
        label: `${getCampaignRevenue(data)} Revenue`,
      },
    ];
  }
}
